// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"87":"373070db19ffb20d06bc","148":"2d1323883846eae720b6","201":"eaa33509af244b4e4cd5"}[chunkId] + ".chunk.js";
};